module.exports = __webpack_public_path__ + "static/media/award01.a807ceab.png";